import { render, staticRenderFns } from "./DemoTag.vue?vue&type=template&id=31b13d06&"
import script from "./DemoTag.vue?vue&type=script&lang=js&"
export * from "./DemoTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports